/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Popover, OverlayTrigger, Row, Col, Form, FormGroup,
    FormControl} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import {connect} from 'react-redux';
import {depthFirstConnected} from './PathComputations';
import {net2NetworkXJSON} from './../../validation/netValid';
import {pathCollectionValidate} from './../../validation/pathValid';


var KShortestPathsDialog = React.createClass({
    getInitialState() {
        let node1, node2,
            nodes = this.props.net.nodes;
        if (nodes.length < 2) {
            node1 = null;
            node2 = null;
        } else {
            node1 = nodes[0].id;
            node2 = nodes[1].id;
        }
        let node = this.props.net.nodes[0];
        return {
            pathObj: null, connected: depthFirstConnected(this.props.net), k: 2,
            src: node1, dst: node2
        };
    },

    componentWillReceiveProps(nextProps) {
        let node1, node2,
            nodes = nextProps.net.nodes;
        if (nodes.length < 2) {
            node1 = null;
            node2 = null;
        } else {
            node1 = nodes[0].id;
            node2 = nodes[1].id;
        }
        let node = this.props.net.nodes[0];
        this.setState({pathObj: null, connected: depthFirstConnected(this.props.net), k: 2,
            src: node1, dst: node2, errorMsg: null});
    },

    srcChange(e) {
        this.setState({src: e.target.value});
    },

    dstChange(e) {
        this.setState({dst: e.target.value});
    },

    kChange(e) {
        this.setState({k: e.target.value});
    },

    helpPopover(){
        return (<Popover id="KShortestPathsHelpPopover"
                         title="K-Shortest Paths Help">
            <p>This command uses a server to compute the k-shortest paths
                between the
                selected nodes for a <em>connected</em> network.</p>
        </Popover>)
    },

    isError () {
        if (!this.state.connected) {
            return true;
        }
        if (this.state.src === this.state.dst) {
            return true;
        }
        if (!this.state.src || !this.state.dst) { // Empty network
            return true;
        }
        if (isNaN(parseInt(this.state.k)) || parseInt(this.state.k) < 1) {
            return true;
        }
        return false;
    },

    computeHandler() {
        if (this.isError()) {
            return;
        }
        let net = net2NetworkXJSON(this.props.net),
            k = parseInt(this.state.k);
        let computeRequest = {
            net: net,
            srcNode: this.state.src,
            dstNode: this.state.dst,
            k: k
        };
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var myInit = {
            method: 'POST',
            body: JSON.stringify(computeRequest),
            headers: myHeaders,
            mode: 'cors',
            cache: 'default'
        };
        let that = this;
        this.setState({errorMsg: "Sending request to server"});
        fetch("http://" + this.props.namePort + "/kShortestPaths", myInit).then(function (response) {
            // console.log(response);
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return response.json().then(function (json) {
                    let result = pathCollectionValidate(JSON.stringify(json));
                    if (result.errors) {
                        that.setState({errorMsg: JSON.stringify(result.errors)});
                        return;
                    } else {
                        // console.log("Got the JSON");
                        // console.log(result.pathObj);
                        that.setState({pathObj: result.pathObj, errorMsg: null});
                        return
                    }
                });
            } else {
                // console.log("not json");
                that.setState({errorMsg: "Server didn't return valid JSON"});
                return;
            }
        }).catch(function (error) {
            that.setState({errorMsg: "Server Error: " + error});
        })
    },

    applyHandler() {
        // console.log(this.state);
        if (this.state.pathObj) {
            this.props.pathCollectionAdd(this.state.pathObj);
        }
        this.setState({pathObj: null});
    },

    textAreaValue() {
        if (!this.state.connected) {
            return "Network is not connected";
        }
        if (this.state.src === this.state.dst) {
            return "Source and Destination cannot be the same";
        }
        if (!this.state.src || !this.state.dst) { // Empty network
            return "Must have at least two nodes in the network";
        }
        if (isNaN(parseInt(this.state.k)) || parseInt(this.state.k) < 1) {
            return "K must be an integer greater than or equal to 1";
        }
        if (this.state.errorMsg) {
            return this.state.errorMsg;
        } else {
            if (this.state.pathObj) {
                return JSON.stringify(this.state.pathObj, null, 2);
            }
        }
        return "";
    },


    render(){
        let nodes = this.props.net.nodes.map(n=>n.id).sort(); // Nodes as a array of strings
        let srcOptions = nodes.map(nstr => <option key={"src_" + nstr}
                                                   value={nstr}>{nstr}</option>);
        let destOptions = nodes.map(nstr => <option key={"dst_" + nstr}
                                                    value={nstr}>{nstr}</option>);
        destOptions.unshift(<option value="_ALL_" key="dst_ALL">All</option>);
        return (
            <Modal show={this.props.open} onHide={this.props.close}
                   dialogClassName="min-span-modal"
                   dialogComponentClass={DraggableModalDialog}
                   enforceFocus={false} backdrop={false}>
                <Modal.Header closeButton>
                    <Modal.Title>K-Shortest Paths via Server</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{paddingBottom: 0}}>
                    <Form horizontal>
                        <FormGroup controlId="srcDstNodes">
                            <Col sm={2}>
                                Source
                            </Col>
                            <Col sm={4}>
                                <FormControl componentClass="select"
                                             onChange={this.srcChange}
                                             value={this.state.src}>
                                    {srcOptions}
                                </FormControl>
                            </Col>
                            <Col sm={2}>
                                Dest
                            </Col>
                            <Col sm={4}>
                                <FormControl componentClass="select"
                                             onChange={this.dstChange}
                                             value={this.state.dst}>
                                    {destOptions}
                                </FormControl>
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="srcDstNodes">
                            <Col sm={2}>
                                K
                            </Col>
                            <Col sm={4}>
                                <FormControl type="text" onChange={this.kChange}
                                             value={this.state.k}>
                                </FormControl>
                            </Col>
                        </FormGroup>
                        <FormControl componentClass="textarea" readOnly
                                     value={this.textAreaValue()}
                                     rows={5} style={{resize: "none"}}/>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary"
                            onClick={this.computeHandler}
                            disabled={this.isError()}>Compute </Button>
                    <Button onClick={this.applyHandler}>Apply</Button>
                    <OverlayTrigger trigger="click" placement="top"
                                    overlay={this.helpPopover()}>
                        <Button bsStyle={'info'}>Help</Button>
                    </OverlayTrigger>
                </Modal.Footer>
            </Modal>
        )
    }
});


const mapStateToProps = (state) => {
    return {
        open: state.uiState.showKShortPathsModal,
        net: state.net,
        paths: state.paths,
        namePort: state.compServe.namePort
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_KSHORT_PATHS_DIALOG'});
        },
        pathCollectionAdd: (pathObj) => {
            dispatch({type: 'PATH_COLLECTION_ADD', pathObj: pathObj});
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KShortestPathsDialog)




// WEBPACK FOOTER //
// ./src/pathComp/KShortestPathsDialog.js